import React, {useEffect} from "react";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

//redux:
import {useSelector, useDispatch} from "react-redux";
import {mediaItemPageActions} from "../../redux/MediaItemPage/mediaItemRedux";

//components:
import {Carousel} from "../../widgets";
import {CircularProgress} from "@material-ui/core";

const CarouselVideoPage = () => {
    const history = useHistory();
    const {videoId} = useParams();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {carousel = [], isLoadingCarousel = false, carouselError = {}} = useSelector(state => state.mediaItemPage);

    useEffect(() => {
        dispatch(mediaItemPageActions.getCarousel());
    }, [videoId]);

    const handleMatchClick = id => {
        history.push(`/media/${id}`);
    };

    if (isLoadingCarousel)
        return (
            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <CircularProgress />
            </div>
        );
    return (
        <Carousel
            type="simple-video-card"
            spaceBetween={20}
            htmlTagTitle={t("HOME.COMPONENTS.NAME.RECOMMENDED")}
            titleClassName="trackpage_all_videos_title mt-12"
            data={carousel}
            onclick={handleMatchClick}
            errorMessage={carouselError.text}
        />
    );
};

export default CarouselVideoPage;
